import React from 'react';
import { observer } from 'mobx-react';
import { useIntl } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../global/sub-window/common/common-close-sub-window-buttons';
import { FormFieldInputText } from '../../../global/form/form-field-input/form-field-input-text';
import { addText, cancelText } from '../../../../constants/common-labels.constants';
import { ADD_ORDER_GROUPS } from '../../../_events/_manage-event/shared/salesforce-order/add-salesforce-order.fields';
import { OrderFormField, visibleFieldsFor } from '../../../_events/_manage-event/shared/salesforce-order/add-salesforce-order-form.presentation';
import { orderTemplateFieldsFor } from '../../../_events/_manage-event/shared/salesforce-order/order-field-dependencies';
import { ORDER_TEMPLATE_FORM_CONFIG, TEMPLATE_DESCRIPTION_KEY, TEMPLATE_NAME_KEY } from './order-template-form.config';
import { OrderTemplateFormVM } from './order-template-form.viewmodel';
import './order-template-form.scss';

const headerField = (key: string) => ORDER_TEMPLATE_FORM_CONFIG.find(field => field.name === key);

type Props = {
    vm: OrderTemplateFormVM;
};

export const OrderTemplateFormPresentation = observer((props: Props): JSX.Element => {
    const { vm } = props;
    const intl = useIntl();
    const nameConfig = headerField(TEMPLATE_NAME_KEY)!;
    const descriptionConfig = headerField(TEMPLATE_DESCRIPTION_KEY)!;
    const groups = ADD_ORDER_GROUPS
        .map(group => ({ group: group, fields: orderTemplateFieldsFor(visibleFieldsFor(vm, group)) }))
        .filter(entry => entry.fields.length > 0);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form oe-form--order-template' data-test-id='order-template-form'>
                    <div className='oe-form__body'>
                        <FormFieldInputText
                            field={vm.getFormVmValuePropsByKey(TEMPLATE_NAME_KEY)}
                            labelDescriptor={nameConfig.labelDescriptor}
                            withError
                            required
                        />
                        <FormFieldInputText
                            field={vm.getFormVmValuePropsByKey(TEMPLATE_DESCRIPTION_KEY)}
                            labelDescriptor={descriptionConfig.labelDescriptor}
                            withError
                        />
                        {groups.map(({ group, fields }) => (
                            <section className='order-template-form__group' key={group.title.id}>
                                <h3 className='order-template-form__group-title'>{intl.formatMessage(group.title)}</h3>
                                {fields.map(field => (
                                    <OrderFormField
                                        vm={vm}
                                        field={field}
                                        className='order-template-form__field'
                                        selectAsLookup
                                        key={field.key}
                                    />
                                ))}
                            </section>
                        ))}
                    </div>
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={addText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.submit}
                        disabled={vm.isSaving || vm.preloadBlocked}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div>
            }
        />
    );
});
